import React, { useState } from 'react';
import TidesFilterApp from './TidesFilterApp';
import WeatherPanel from './components/weather/WeatherPanel.jsx';
import Grid from './Grid.jsx';

function App() {
  return (
    <>
      <WeatherPanel/>
      <TidesFilterApp />      
      </>  
  );
}


export default App;
